// De standaardteksten van de widget voor het tabblad Weergave > Teksten in het dashboard (Martijn 11-10-2026).
//
// Een leeg tekstveld in het dashboard toont nu de tekst die de widget zelf laat zien, in de taal van het voorbeeld. Die tekst
// komt uit precies dezelfde plek als in de widget (languageWords van de module, de eigen kop uit de opmaak, teksten.json),
// zodat dashboard en widget hetzelfde zeggen. De widget meldt ze in het live voorbeeld met een bericht aan het dashboard.
// Alleen teksten waar de widget een standaard voor heeft; de starttekst heeft er geen.
import { startknopTekst } from './weergave';
import { eigenKop } from './widgetteksten';
import { tekst as jmTekst, vertaal as jmVertaal } from './woorden';

export const STANDAARDTEKSTEN_TYPE = 'standaardteksten';

/**
 * @param {object} p
 * @param {string} p.module        horeca, activity, salon, ticketing
 * @param {object} p.languageWords de woorden van de module
 * @param {string} p.kopUitOpmaak  MainText_fieldText uit de opmaak (Overall)
 * @param {string} p.zaakknop      de reserveerknop van de zaak (widgetSettings.buttonText)
 */
export function standaardteksten({ module, languageWords, kopUitOpmaak, zaakknop }) {
    const soort = String(module || '').toLowerCase();
    const woorden = languageWords || {};
    const uit = {
        kop: eigenKop(kopUitOpmaak) || woorden.widgetHeading || jmTekst(woorden, 'widgetHeading', 'Start je reservering'),
        voorwaardentekst: jmVertaal('Ik ga akkoord met de voorwaarden'),
    };

    if (soort === 'ticketing') {
        uit.startknop = jmVertaal('Verder');
    } else {
        uit.startknop = startknopTekst(null, soort, zaakknop, woorden.Booknow);
    }

    uit.boekknop = soort === 'salon' ? jmVertaal('Bevestigen') : jmTekst(woorden, 'Booknow', 'Reserve');
    if (soort === 'activity' && woorden.ReservationSuccessInfo) uit.bevestiging = woorden.ReservationSuccessInfo;

    // Alleen echte teksten.
    for (const sleutel of Object.keys(uit)) {
        if (typeof uit[sleutel] !== 'string' || !uit[sleutel].trim()) delete uit[sleutel];
    }
    return uit;
}
